import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "title", "body"]
  static values = {
    msgLoading: { type: String, default: "로딩 중..." },
    msgLoadingBody: { type: String, default: "약관을 불러오는 중입니다..." },
    msgNoContent: { type: String, default: "등록된 약관 내용이 없습니다." },
    msgFetchError: { type: String, default: "약관을 불러오는 중 오류가 발생했습니다." },
    titleTos: { type: String, default: "이용약관" },
    titlePrivacy: { type: String, default: "개인정보 처리방침" },
    titleMarketing: { type: String, default: "마케팅 정보 수신 동의" }
  }

  open(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.termsType
    this.showLoading()
    this.overlayTarget.style.display = "flex"
    document.body.style.overflow = "hidden"

    fetch(this.contentUrl(type), {
      headers: { "Accept": "application/json" }
    })
      .then(res => res.json())
      .then(data => {
        if (data.title) {
          this.titleTarget.textContent = data.title
          this.bodyTarget.innerHTML = this.formatContent(data.content)
        } else {
          this.titleTarget.textContent = this.fallbackTitles[type] || ""
          this.bodyTarget.innerHTML = `<p style='color:#6B7280;'>${this.msgNoContentValue}</p>`
        }
      })
      .catch(() => {
        this.titleTarget.textContent = this.fallbackTitles[type] || ""
        this.bodyTarget.innerHTML = `<p style='color:#ef4444;'>${this.msgFetchErrorValue}</p>`
      })
  }

  close() {
    this.overlayTarget.style.display = "none"
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  showLoading() {
    this.titleTarget.textContent = this.msgLoadingValue
    this.bodyTarget.innerHTML = `<p style='color:#6B7280;text-align:center;padding:24px 0;'>${this.msgLoadingBodyValue}</p>`
  }

  formatContent(content) {
    if (!content) return ""
    return content
      .split(/\n\n+/)
      .map(para => `<p style="margin: 0 0 10px;">${para.replace(/\n/g, "<br>")}</p>`)
      .join("")
  }

  get fallbackTitles() {
    return {
      tos: this.titleTosValue,
      terms: this.titleTosValue,
      privacy: this.titlePrivacyValue,
      marketing: this.titleMarketingValue
    }
  }

  contentUrl(type) {
    const url = new URL(`/terms/${type}/content`, window.location.origin)
    const locale = new URLSearchParams(window.location.search).get("locale")
    if (locale) url.searchParams.set("locale", locale)
    return url.toString()
  }
}
